import { EnumSchema, FromSchema } from '@40seas/entities/common';
import { FeeDefinitionType } from 'libs/entities/fees/src/lib/fee-definition.type.enum';
import { z } from 'zod';

export const FeeSchema = z
    .object({
        fixed: z
            .number()
            .nullish()
            .refine((val) => val === null || val === undefined || +val.toFixed(2) === val, {
                message: 'fixed must have no more than 2 decimal places',
                path: ['fixed'],
            }),
        percentage: z
            .number()
            .min(-100)
            .max(100)
            .optional()
            .refine((val) => val === undefined || +val.toFixed(2) === val, {
                message: 'percentage must have no more than 2 decimal places',
                path: ['percentage'],
            }),
        result: z.number().nullish(),
        feeDefinition: z.string().optional(), // TODO: FS-5663 remove optionl
        feeDefinitionType: EnumSchema(FeeDefinitionType).optional(), // TODO: FS-5663 remove optionl
    })
    .strict();

export class Fee extends FromSchema(FeeSchema) {
    fixed?: number;
    percentage?: number;
    result?: number;
    feeDefinition?: string; // TODO: FS-5663 remove optionl
    feeDefinitionType?: FeeDefinitionType; // TODO: FS-5663 remove optionl
}
